// import BannerImg from "../../Assets/BannerImg1.png";

// const FirstBanner = () => {
//   return (
//     <section className="relative w-full overflow-hidden">
//       {/* Background Container for the Shape */}
//       <div className="relative w-full overflow-hidden">
//         {/* The Clipped Banner Image */}
//         <div className="w-full h-full">
//           <img
//             src={BannerImg}
//             alt="AI Concept Art"
//             className="w-full h-auto object-cover object-center"
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FirstBanner;

import BannerImg from "../../Assets/BannerImg1.png";

const FirstBanner = () => {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative w-full overflow-hidden">

        {/* Image */}
        <img
          src={BannerImg}
          alt="AI Concept Art"
          className="w-full h-auto object-cover object-center"
        />

        {/* Shining Blur Effect */}
        <div className="shine-effect" />

      </div>
    </section>
  );
};

export default FirstBanner;
